import React from 'react'
import { motion } from "framer-motion";
// import { Link } from "react-scroll";

function HowItWorks() {
  return (
    <div>
        {/* ===== HOW IT WORKS ===== */}
      <section id="how" className="how">
        <h2 className="section__title">How It Works</h2>
        <div className="container how__steps">
          {["Upload Document", "AI Review", "Take Action"].map((step, i) => (
            <motion.div
              className="step"
              key={i}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.3 }}
            >
              <span className="step__num">{i + 1}</span>
              <h4>{step}</h4>
              <p>
                {i === 0
                  ? "Select your contract and upload it securely."
                  : i === 1
                  ? "AI scans and summarizes key risks instantly."
                  : "Download a clean, reviewed version or share it."}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

    </div>
  )
}

export default HowItWorks